import { useEffect, useState } from 'react';

function useOnlineStatus(
  // pingCheck = false,
  // pingUrl = 'https://www.google.com/favicon.ico'
) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => {
      // if (pingCheck) {
      //   // Validasi dengan ping ke internet
      //   fetch(pingUrl, { method: 'HEAD', mode: 'no-cors' })
      //     .then(() => setIsOnline(true))
      //     .catch(() => setIsOnline(false));
      // } else {
      setIsOnline(navigator.onLine);
      // }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Cek awal
    updateOnlineStatus();

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return isOnline;
}

export default useOnlineStatus;
